import { createContext, useContext, useMemo } from 'react';

import useAutoCallFeature from '@/app/mutations/Shared/useAutoCallFeature';
import { StopOptions } from '@/app/mutations/Shared/types';

export interface Transcription {
  isTranscribing: boolean;
  // A start is dispatched but has not resolved yet.
  isStartPending: boolean;
  start(): void;
  stop(options?: StopOptions): void;
}

export const TranscriptionContext = createContext<Transcription>(null!);

export function useTranscription() {
  return useContext(TranscriptionContext);
}

export function useAutoTranscription({ joined }: { joined: boolean }, isEnabled: boolean) {
  const transcription = useTranscription();
  const feature = useMemo(() => ({
    isActive: transcription.isTranscribing,
    isStartPending: transcription.isStartPending,
    start: transcription.start,
    stop: transcription.stop,
  }), [
    transcription.isTranscribing,
    transcription.isStartPending,
    transcription.start,
    transcription.stop,
  ]);
  useAutoCallFeature({ joined, isEnabled }, feature);
}
